import type { KeyboardEvent, Ref } from 'react';

import { fieldStyle } from '../dashboards/primitives';

interface Props {
  id: string;
  inputRef: Ref<HTMLInputElement>;
  listId: string;
  activeId: string | undefined;
  open: boolean;
  text: string;
  hasValue: boolean;
  padRight: boolean;
  required: boolean;
  error?: string;
  errorId: string;
  onOpen: () => void;
  onClose: () => void;
  onSearch: (text: string) => void;
  onKeyDown: (e: KeyboardEvent) => void;
}

/** The combobox text box. It shows the current name; clicking opens the list
 *  and selects the text so typing replaces it. */
export default function PeoplePickerInput(p: Props) {
  return (
    <input
      id={p.id}
      ref={p.inputRef}
      role="combobox"
      aria-expanded={p.open}
      aria-controls={p.listId}
      aria-autocomplete="list"
      aria-required={p.required ? true : undefined}
      aria-invalid={p.error ? true : undefined}
      aria-describedby={p.error ? p.errorId : undefined}
      aria-activedescendant={p.open ? p.activeId : undefined}
      value={p.text}
      placeholder={p.hasValue ? undefined : 'Search people…'}
      onClick={(e) => {
        if (!p.open) p.onOpen();
        e.currentTarget.select();
      }}
      onBlur={p.onClose}
      onChange={(e) => p.onSearch(e.target.value)}
      onKeyDown={p.onKeyDown}
      style={fieldStyle(p.error ? 'error' : undefined, { paddingRight: p.padRight ? 34 : 10 })}
    />
  );
}
